import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { useLanguage } from '../../contexts/LanguageContext'
import { CheckCircleIcon, XMarkIcon } from '@heroicons/react/24/outline'

export default function FormSuccessModal({ open, onClose, title, message }) {
  const { t } = useLanguage()

  useEffect(() => {
    if (!open) return undefined

    const onKeyDown = (event) => {
      if (event.key === 'Escape') onClose()
    }

    document.body.style.overflow = 'hidden'
    window.addEventListener('keydown', onKeyDown)

    return () => {
      document.body.style.overflow = ''
      window.removeEventListener('keydown', onKeyDown)
    }
  }, [open, onClose])

  const closeLabel = t('common.close')

  if (!open || typeof document === 'undefined') return null

  return createPortal(
    <div
      className="fixed inset-0 z-[300] flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="form-success-title"
    >
      <button
        type="button"
        className="absolute inset-0 bg-brand-navy/55 backdrop-blur-[2px]"
        onClick={onClose}
        aria-label={closeLabel}
      />

      <div className="relative w-full max-w-md bg-white shadow-[0_24px_48px_-12px_rgba(16,34,64,0.28)]">
        <button
          type="button"
          onClick={onClose}
          className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center text-slate-400 transition-colors hover:text-brand-navy"
          aria-label={closeLabel}
        >
          <XMarkIcon className="h-5 w-5" />
        </button>

        <div className="px-8 pb-8 pt-10 text-center">
          <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-[#0d5c35]">
            <CheckCircleIcon className="h-8 w-8 text-white" strokeWidth={2} />
          </div>
          <h3 id="form-success-title" className="font-heading text-xl font-bold text-brand-navy">
            {title}
          </h3>
          <p className="mt-3 text-[15px] leading-relaxed text-slate-600">{message}</p>
        </div>
      </div>
    </div>,
    document.body
  )
}
